module.exports = __webpack_public_path__ + "static/media/s12 — kopia.c6a6bcbb.jpg";